

export const ofOptions = Object.freeze({
    Semi: { id: 0, name: "Semi" },
    GD: { id: 1, name: "GD" },
    Customer: { id: 2, name: "Customer" },
    GDCust: { id: 3, name: "GDCust" },
    Outside: { id: 4, name: "Outside" },
    GDOldLot: { id: 5, name: "GD Old Lot" },

    fromId(id) {
        return Object.values(ofOptions).find(state => state.id === id) || ofOptions.GD;
    },

    toList() {
        return Object.values(ofOptions).filter(state => typeof state !== 'function');
    }
});

export const prFormulaOptions = Object.freeze({
    Empty: { id: 0, name: " ", code : " ",},
    At: { id: 1, name: "@", code : "@" ,},
    Unit: { id: 2, name: "Unit", code : "U", },
    Direct: { id: 3, name: "Direct", code : "D", },
    Semi: { id: 4, name: "Semi", code : "S@" ,},

    fromId(id) {
        return Object.values(prFormulaOptions).find(state => state.id === id) || prFormulaOptions.Empty;
    },

    toList() {
        return Object.values(prFormulaOptions).filter(state => typeof state !== 'function');
    }
});

export const prCurrencyOptions = Object.freeze({
    Empty: { id: 0, name: " " },
    USD: { id: 1, name: "USD" },
    MMK: { id: 2, name: "MMK" },
    GoldKPY: { id: 8, name: "Gold KPY" },
    GoldG: { id: 9, name: "Gold g" },
    ACADEMY: { id: 16, name: "ACADEMY" },
    PLRG15: { id: 15, name: "15PLRG" },
    PLWG14: { id: 14, name: "14PLWG" },
    PLYG13: { id: 13, name: "13PLYG" },

    fromId(id) {
        return Object.values(prCurrencyOptions).find(state => state.id === id) || prCurrencyOptions.Empty;
    },

    toList() {
        return Object.values(prCurrencyOptions).filter(state => typeof state!== 'function');
    }

});


export const prUnitOptions = Object.freeze({
    Ct: { id: 1, name: "ct" },
    Rt: { id: 4, name: "rt" },

    fromId(id) {
        return Object.values(prUnitOptions).find(state => state.id === id) || prUnitOptions.Ct;
    },

    toList() {
        return Object.values(prUnitOptions).filter(state => typeof state!== 'function');
    }
});

export const wtUnitOptions = Object.freeze({
    Ct: { id: 1, name: "ct" },
    G: { id: 2, name: "g" },
    KPY: { id: 3, name: "kpy" },
    Rt: { id: 4, name: "rt" },

    fromId(id) {
        return Object.values(wtUnitOptions).find(state => state.id === id) || wtUnitOptions.Ct;
    },
    toList() {
        return Object.values(wtUnitOptions).filter(state => typeof state!== 'function');
    }
});

export const qtyUnitOptions = Object.freeze({
    Pc: { id: 1, name: "pc" },
    Hf: { id: 2, name: "hf" },
    Pr: { id: 3, name: "pr" },
    Set: { id: 4, name: "set" },
    Pai: { id: 5, name: "pai" },
    Sa: { id: 6, name: "sa" },

    fromId(id) {
        return Object.values(qtyUnitOptions).find(state => state.id === id) || qtyUnitOptions.Pc;
    },
    toList() {
        return Object.values(qtyUnitOptions).filter(state => typeof state!== 'function');
    }
});


export const productStatusOptions = Object.freeze({
    NA: { id: 0, name: 'NA', textColor: '#CCCCCC', fillColor: '#F0F0F0' }, // Light Gray (Neutral)
    Deleted: { id: -1, name: 'Deleted', textColor: '#9E9E9E', fillColor: '#E0E0E0' }, // Dark Gray (Inactive)
    Instock: { id: 1, name: 'Instock', textColor: '#228B22', fillColor: '#E6FFEF' }, // Green (Available)
    SoldOut: { id: 2, name: 'Sold Out', textColor: '#E35F00', fillColor: '#FFEBE6' }, // Orange (Limited)
    Pandy: { id: 3, name: 'Pandy', textColor: '#3C7BAA', fillColor: '#E3F2FD' }, // Blue (Processing or In Transit)
    Sample: { id: 4, name: 'Sample', textColor: '#9C27B0', fillColor: '#F3E5F5' }, // Purple (Test or Special)
    Dismantled: { id: 5, name: 'Dismantled', textColor: '#FF8C00', fillColor: '#FFE0B2' }, // Orange-Brown (Deconstructed)
    Destroyed: { id: 6, name: 'Destroyed', textColor: '#B71C1C', fillColor: '#FFCDD2' }, // Dark Red (Permanent Removal)
    Transfer: { id: 7, name: 'Transfer', textColor: '#00ACC1', fillColor: '#E0F7FA' }, // Cyan (Moving/Relocating)
    ReturnedIn: { id: 8, name: 'Returned In', textColor: '#3F51B5', fillColor: '#E8EAF6' }, // Indigo (Reverted or Restocked)
    Vault: { id: 9, name: 'Vault', textColor: '#4A148C', fillColor: '#EDE7F6' }, // Deep Purple (Secure Storage)
    
    fromId(id) {
        return Object.values(productStatusOptions).find(state => state.id === id) || productStatusOptions.NA;
    },
    toList() {
        return Object.values(productStatusOptions).filter(state => typeof state!== 'function');
    }
});
export const productStateOptions = Object.freeze({
    NA: {
        id: 0,
        name: "N/A",
        textColor: "#CCCCCC",
        fillColor: "#F0F0F0", // Neutral Gray
    },
    Whole: {
        id: 1,
        name: "Whole",
        textColor: "#2E7D32",
        fillColor: "#E8F5E9", // Strong Green
    },
    Semi: {
        id: 2,
        name: "Semi",
        textColor: "#0277BD",
        fillColor: "#E1F5FE", // Blue-ish tone for partial
    },
    Half: {
        id: 3,
        name: "Half",
        textColor: "#F57C00",
        fillColor: "#FFF3E0", // Orange (middle state)
    },
    HalfSemi: {
        id: 4,
        name: "Half Semi",
        textColor: "#8E24AA",
        fillColor: "#F3E5F5", // Purple (complex state)
    },
    WholeHalf: {
        id: 5,
        name: "Whole Half",
        textColor: "#6D4C41",
        fillColor: "#EFEBE9", // Brown (mixed/dual state)
    },
    SemiHalf: {
        id: 6,
        name: "Semi Half",
        textColor: "#00897B",
        fillColor: "#E0F2F1", // Teal (mixed/complex)
    },

    fromId(id) {
        return Object.values(productStateOptions).find(state => state.id === id) || productStateOptions.NA;
    },
    toList() {
        return Object.values(productStateOptions).filter(state => typeof state !== 'function');
    }
});

export const productPtOptions = Object.freeze({
    No: { id: 0, name: "No" },
    Yes: { id: 1, name: "Yes" },

    fromId(id) {
        return Object.values(productPtOptions).find(state => state.id === id) || productPtOptions.No;
    },
    toList() {
        return Object.values(productPtOptions).filter(state => typeof state!== 'function');
    }
});

export const componentTypesOptions = Object.freeze({
    Gold: { id: 0, name: "Gold" },
    Fixed: { id: 1, name: "Fixed" },
    Unique: { id: 2, name: "Unique" },
    Metal: { id: 3, name: "Metal" },

    fromId(id) {
        return Object.values(componentTypesOptions).find(state => state.id === id) || componentTypesOptions.Gold;
    },
    toList() {
        return Object.values(componentTypesOptions).filter(state => typeof state!== 'function');
    }
});


export const componentState = Object.freeze({
    NA: { id: 0, name: 'NA', textColor: '#CCCCCC', fillColor: '#CCCCCC'  }, // Light gray
    Available: { id: 1, name: 'Available',name2: 'Available', textColor: '#228B26', fillColor: '#E6FFEF' }, // Green
    LowStock: { id: 2, name: 'Low Stock', name2: 'Sold Out', textColor: '#E35F00', fillColor: '#FFCDD2'  }, // Orange
    Restock: { id: 3, name: 'Restock', name2: 'Returned In', textColor: '#3C7BAA', fillColor: '#E3F2FD'  }, // Blue
    Unavailable: { id: 9, name: 'Unavailable',name2: 'Unavailable', textColor: '#E53935', fillColor: '#FFCDD2'  }, // Red
  
    fromId(id) {
      return Object.values(componentState).find(status => status.id === id) || componentState.NA;
    }
});

export const smsDisplayState = Object.freeze({
    None: { id: 0, name: 'None', textColor: '#CCCCCC', fillColor: '#F5F5F5' }, // Light gray
    Available: { id: 1, name: 'Available', textColor: '#228B22', fillColor: '#E6FFEF' }, // Green
    Full: { id: 2, name: 'Full', textColor: '#1E3A8A', fillColor: '#E0F7FA' }, // Blue
  
    fromId(id) {
        return Object.values(smsDisplayState).find(state => state.id === id) || smsDisplayState.None;
    }
});

export const smsSlotState = Object.freeze({
    None: { id: 0, name: 'None', textColor: '#CCCCCC', fillColor: '#F5F5F5' }, // Light gray
    Instock: { id: 1, name: 'Instock', textColor: '#228B22', fillColor: '#E6FFEF' }, // Green
    Occupied: { id: 2, name: 'Occupied', textColor: '#1E3A8A', fillColor: '#E0F7FA' }, // Blue
  
    fromId(id) {
        return Object.values(smsSlotState).find(state => state.id === id) || smsSlotState.None;
    }
});

export const smsTrackRecordState = Object.freeze({
    Active: { id: 1, name: 'Active', textColor: '#228B22', fillColor: '#E6FFEF' },
    Complete: { id: 0, name: 'Complete',  textColor: '#1E3A8A', fillColor: '#E0F7FA'  },
  
    fromId(id) {
        return Object.values(smsTrackRecordState).find(state => state.id === id) || smsTrackRecordState.Instock;
    }
});

export const trackRecordInType = Object.freeze({
  NA: { id: 0, name: "NA" },
  HardCodedIn: { id: 1, name: "Hard-coded" },
  Produced: { id: 2, name: "Produced" },
  Pandy: { id: 3, name: "Pandy" },
  Sample: { id: 4, name: "Sample" },
  TransferIn: { id: 5, name: "Transfer" },
  Store: {id: 6, name: "Store"},

  fromId(id) {
      return Object.values(trackRecordInType).find(type => type.id === id) || trackRecordInType.NA;
  },
  toList() {
      return Object.values(trackRecordInType).filter(type => typeof type !== 'function');
  }
});

export const trackRecordOutType = Object.freeze({
  NA: { id: 0, name: "NA" },
  HardCodedOut: { id: 1, name: "Hard-coded" },
  SoldOut: { id: 2, name: "Sold Out" },
  Pandy: { id: 3, name: "Pandy" },
  Sample: { id: 4, name: "Sample" },
  TransferOut: { id: 5, name: "Transfer" },
  StoreOut: {id: 6, name: "Store"},

  fromId(id) {
      return Object.values(trackRecordOutType).find(type => type.id === id) || trackRecordOutType.NA;
  },
  toList() {
      return Object.values(trackRecordOutType).filter(type => typeof type !== 'function');
  }
});


export const cashIoType = Object.freeze({
    CashOut: { id: 0, name: "Cash Out", textColor: '#E53935', fillColor: '#FFCDD2' , icon: "el-icon-caret-bottom" }, // Red up arrow for Cash Out
    CashIn: { id: 1, name: "Cash In", textColor: '#228B22', fillColor: '#E6FFEF', icon: "el-icon-caret-top" }, // Green down arrow for Cash In

    fromId(id) {
        return Object.values(cashIoType).find(state => state.id === id) || cashIoType.CashIn;
    },
    toList() {
        return Object.values(cashIoType).filter(state => typeof state !== 'function');
    }
});

export const cashBookType = Object.freeze({
    NA : { id : 0, name : "NA"},
    SaleBook : {id: 1, name: "Sale Book"},
    CashBook : {id : 2, name: "Cash Book"},
    GSBook : {id: 3, name: "GS Book"},
    SRBook : {id: 4, name: "SR Book"},
    PettyCash : {id: 5, name: "Petty Cash"},
    Suboo : {id: 6, name: "Suboo"},

    fromId(id) {
        return Object.values(cashBookType).find(state => state.id === id) || cashBookType.NA;
    },

    toList() {
        return Object.values(cashBookType).filter(state => typeof state !== 'function');
    } 
});

export const cashTransactionMode = Object.freeze({
    NA : { id : 0, name : "NA"},
    Cash : { id : 1, name : "Cash"},
    ForeignCurrency : { id : 2, name : "Foreign Currency"},
    Cheque : { id : 3, name : "Cheque"},
    Bank : { id : 4, name: "Bank"},
    IBanking : { id : 5, name: "iBanking"},

    fromId(id) {
        return Object.values(cashTransactionMode).find(state => state.id === id) || cashTransactionMode.NA;
    },

    toList() {
        return Object.values(cashTransactionMode).filter(state => typeof state !== 'function');
    } 
});


export const cashCurrency = Object.freeze({
    NA : { id : 0, name : "NA"},
    USD : { id : 1, name : "USD"},
    MMK : { id : 2, name : "MMK"},
    THB : { id : 3, name : "THB"},
    SGD : { id : 4, name : "SGD"},
    HKD : { id : 5, name : "Hong Kong Dollar"},
    EUR : { id : 8, name : "Euros"},

    fromId(id) {
        return Object.values(cashCurrency).find(state => state.id === id) || cashCurrency.NA;
    },

    toList() {
        return Object.values(cashCurrency).filter(state => typeof state !== 'function');
    }    
});



export const itemIoType = Object.freeze({
    ItemOut: { id: 0, name: "Item Out", textColor: '#E53935', fillColor: '#FFCDD2' , icon: "el-icon-top" }, // Red up arrow for Cash Out
    ItemIn: { id: 1, name: "Item In", textColor: '#228B22', fillColor: '#E6FFEF', icon: "el-icon-bottom" }, // Green down arrow for Cash In

    fromId(id) {
        return Object.values(itemIoType).find(state => state.id === id) || itemIoType.ItemIn;
    },
    toList() {
        return Object.values(itemIoType).filter(state => typeof state !== 'function');
    }
});

export const transactionFor = Object.freeze({
    NA: { id: 0, name: "NA" },
    OrderForm: { id: 1, name: "Order Form" },
    Voucher: { id: 2, name: "Voucher" },
    ReturnIn: { id: 3, name: "Return In" },
    Transfer: { id: 4, name: "Transfer" },
    Pandy: { id: 5, name: "Pandy" },
    Purchase: {id: 6, name: "Purchase"},
    GsFlow: {id: 7, name: "Gs Flow"},
    Adjustment: { id: 9, name: "Adjustment" },
  
    fromId(id) {
      return Object.values(transactionFor).find(state => state.id === id) || transactionFor.NA;
    },
  
    toList() {
      return Object.values(transactionFor).filter(state => typeof state !== 'function');
    }
  });
  

export const inventoryType = Object.freeze({
    NA: { id: 0, name: "NA" },
    GDProductCatalog: { id: 1, name: "Product Catalog" },
    GoldInventory: { id: 2, name: "Gold Inventory" },
    FixedInventory: { id: 3, name: "Fixed Inventory" },
    UniqueInventory: { id: 4, name: "Unique Inventory" },

    fromId(id) {
        return Object.values(inventoryType).find(type => type.id === id) || inventoryType.NA;
    },

    toList() {
        return Object.values(inventoryType).filter(type => typeof type !== 'function');
    }
});

export const voucherStatus = Object.freeze({
    BalanceRemain: { 
      id: 0, 
      name: "Balance Remain", 
      textColor: "#FF9800", // Orange
      fillColor: "#FFF3E0"  // Light Orange
    },
    NoBalance: { 
      id: 1, 
      name: "No Balance", 
      textColor: "#4CAF50", // Green
      fillColor: "#E8F5E9"  // Light Green
    },
    OrderFormAudit: { 
      id: 2, 
      name: "Order Form Audit", 
      textColor: "#2196F3", // Blue
      fillColor: "#E3F2FD"  // Light Blue
    },
  
    fromId(id) {
      return Object.values(voucherStatus).find(status => status.id === id) || voucherStatus.BalanceRemain;
    },
  
    toList() {
      return Object.values(voucherStatus).filter(status => typeof status !== 'function');
    }
  });
  
  export const rateType = Object.freeze({
    NA: { id: 0, name: "NA" },
    LockedRate: { id: 1, name: "Locked Rate (Order Form)" },
    TodayRate: { id: 2, name: "Today Rate (Voucher)" },
    
    fromId(id) {
      return Object.values(rateType).find(type => type.id === id) || rateType.NA;
    },
  
    toList() {
      return Object.values(rateType).filter(type => typeof type !== 'function');
    }
  });
  
  export const orderItemType = Object.freeze({
    NA: { id: 0, name: "NA" },
    CustomizedDesign: { id: 1, name: "Customized Design" },
    Repair: { id: 2, name: "Repair" },
    Destroyed: { id: 3, name: "Destroyed" },
    GoldCasting : { id: 4, name: "Gold Casting"},
    // Add other types as needed
  
    fromId(id) {
      return Object.values(orderItemType).find(type => type.id === id) || orderItemType.NA;
    },
  
    toList() {
      return Object.values(orderItemType).filter(type => typeof type !== 'function');
    }
  });
  
  export const returnInStatus = Object.freeze({
    BalanceRemain: { 
      id: 0, 
      name: "Balance Remain", 
      textColor: "#FF9800", // Orange
      fillColor: "#FFF3E0"  // Light Orange
    },
    NoBalance: { 
      id: 1, 
      name: "No Balance", 
      textColor: "#4CAF50", // Green
      fillColor: "#E8F5E9"  // Light Green
    },
    fromId(id) {
      return Object.values(returnInStatus).find(status => status.id === id) || returnInStatus.BalanceRemain;
    },
  
    toList() {
      return Object.values(returnInStatus).filter(status => typeof status !== 'function');
    }
  });

  export const pandyType = Object.freeze({
    NA: { id: 0, name: "NA" },
    Customer: { id: 1, name: "Customer" },
    Smith: { id: 2, name: "Smith" },
    // Add other types as needed
  
    fromId(id) {
      return Object.values(pandyType).find(type => type.id === id) || pandyType.NA;
    },
  
    toList() {
      return Object.values(pandyType).filter(type => typeof type !== 'function');
    }
  });

  export const pandyStatus = Object.freeze({
    No: { 
      id: 0, 
      name: "No", 
      textColor: '#E53935', // Red
      fillColor: '#FFCDD2' // Light red
    },
    Yes: { 
      id: 1, 
      name: "Yes",
      textColor: "#4CAF50", // Green
      fillColor: "#E8F5E9"  // Light Green
    },
    Partial:{
        id: 2,
        name: "Partial",
        textColor: "#FF9800", // Orange
        fillColor: "#FFF3E0"  // Light Orange
    },

    fromId(id) {
      return Object.values(pandyStatus).find(status => status.id === id) || pandyStatus.No;
    },
  
    toList() {
      return Object.values(pandyStatus).filter(status => typeof status !== 'function');
    }
  });

  export const isReturnedReceived = Object.freeze({
    No: { 
      id: 0, 
      name: "No", 
      textColor: '#E53935', // Red
      fillColor: '#FFCDD2' // Light red
    },
    Yes: { 
      id: 1, 
      name: "Yes",
      textColor: "#4CAF50", // Green
      fillColor: "#E8F5E9"  // Light Green
    },

    fromId(id) {
      return Object.values(isReturnedReceived).find(status => status.id === id) || isReturnedReceived.No;
    },
  
    toList() {
      return Object.values(isReturnedReceived).filter(status => typeof status !== 'function');
    }
  });

  export const inventoryRecordType = Object.freeze({
    NewIn: { id: 0, name: "New In", code: "NI" },
    StoreIn: { id: 1, name: "Store In", code: "SI" },
    PandyIn: { id: 2, name: "Pandy In", code: "PI" },
    SampleIn: { id: 3, name: "Sample In", code: "SAI" },
    RepairIn: { id: 4, name: "Repair In", code: "RI" },
    TransferIn: { id: 5, name: "Transfer In", code: "TI" },
    ReturnIn: { id: 6, name: "Return In", code: "RNI" },
    SoldOut: { id: 7, name: "Sold Out", code: "SO" },
    PresentOut: { id: 8, name: "Present Out", code: "PO" },
    PandyOut: { id: 9, name: "Pandy Out", code: "PAO" },
    SampleOut: { id: 10, name: "Sample Out", code: "SAO" },
    ReturnOut: { id: 11, name: "Return Out", code: "RO" },
    RepairOut: { id: 12, name: "Repair Out", code: "REO" },
    StoreOut: { id: 13, name: "Store Out", code: "SOO" },
    TransferOut: { id: 14, name: "Transfer Out", code: "TO" },
    DestroyOut: { id: 15, name: "Destroy Out", code: "DO" },
    GsOut: { id: 16, name: "GS Out", code: "GSO" },

    fromId(id) {
        return Object.values(prFormulaOptions).find(state => state.id === id) || prFormulaOptions.NewIn;
    },

    toList() {
        return Object.values(prFormulaOptions).filter(state => typeof state !== "function");
    }
});

// INIT(0, "Initial"),
// BLOC(1, "Bloc"),
// MANUAL(2, "Manual"),
// FINAL(9, "Final");
export const inventoryRecordState = Object.freeze({
  INIT: { 
    id: 0, 
    name: "Initial", 
    textColor: "#4CAF50", // Green
    fillColor: "#E8F5E9"  // Light Green
  
  },
  BLOC: { 
    id: 1, 
    name: "Change",
    textColor: '#E53935', // Red
    fillColor: '#FFCDD2' // Light red
  },
  MANUAL:{
      id: 2,
      name: "Manual",
      textColor: "#FF9800", // Orange
      fillColor: "#FFF3E0"  // Light Orange
  },
  FINAL:{
    id: 9,
    name: "Final",
    textColor: '#1E3A8A',
    fillColor: '#E0F7FA'
},

  fromId(id) {
    return Object.values(inventoryRecordState).find(status => status.id === id) || inventoryRecordState.INIT;
  },
})


export const returnInState = Object.freeze({
  NoInstock: { id: 0, name: 'No Instock',  textColor: '#9E9E9E', fillColor: '#E0E0E0' }, // Dark Gray (Neutral)
  FullInstock: { id: 1, name: 'Full Instock', textColor: '#228B22', fillColor: '#E6FFEF' }, // Green (Available)
  PartialInstock: { id: 2, name: 'Partial Instock', textColor: '#E35F00', fillColor: '#FFEBE6' }, // Orange (Limited)
  NA: { id: -1, name: 'NA', textColor: '#CCCCCC', fillColor: '#F5F5F5'  }, // Light gray

  fromId(id) {
      return Object.values(returnInState).find(state => state.id === id) || returnInState.NA;
  },
  toList() {
      return Object.values(returnInState).filter(state => typeof state!== 'function');
  }
});



export const returnInItemState = Object.freeze({
  ReturnIn: { id: 8, name: 'Return In',  textColor: '#9E9E9E', fillColor: '#E0E0E0' }, // dark Gray (Neutral)
  Instock: { id: 1, name: 'Instock', textColor: '#228B22', fillColor: '#E6FFEF' }, // Green (Available)
  NA: { id: -1, name: 'NA', textColor: '#CCCCCC', fillColor: '#F5F5F5'  }, // Light gray

  fromId(id) {
      return Object.values(returnInItemState).find(state => state.id === id) || returnInItemState.NA;
  },
  toList() {
      return Object.values(returnInItemState).filter(state => typeof state!== 'function');
  }
});


export const payForTypeOptions = Object.freeze({
    OrderForm: { id: 1, name: 'Order Form' },
    Voucher:   { id: 2, name: 'Voucher' },

    fromId(id) {
        return Object.values(payForTypeOptions).find(s => s.id === id) || payForTypeOptions.Voucher;
    },
    toList() {
        return Object.values(payForTypeOptions).filter(s => typeof s !== 'function');
    }
});

export const usdMmkOption = Object.freeze({
    USD : { id : 1, name : "USD"},
    MMK : { id : 2, name : "MMK"},
    Combo : { id : 9, name: "Combo"},
    NA : { id : 0, name: "-"},
   
    fromId(id) {
        return Object.values(usdMmkOption).find(state => state.id === id) || usdMmkOption.MMK;
    },

    toList() {
        return Object.values(usdMmkOption).filter(state => typeof state !== 'function');
    }    
});



export const quoteType = Object.freeze({
    NORMAl : { id : 1, name : "NORMAL"},
    GIA : { id : 2, name : "GIA"},
   
    fromId(id) {
        return Object.values(quoteType).find(state => state.id === id) || quoteType.NORMAl;
    },

    toList() {
        return Object.values(quoteType).filter(state => typeof state !== 'function');
    }    
});

export const academyGoldTnxTypeOptions = Object.freeze({
  Buy: {
    id: 1,
    name: "Buy",
    textColor: "#2E7D32", // Green
    fillColor: "#E8F5E9"
  },
  Sell: {
    id: 2,
    name: "Sell",
    textColor: "#C62828", // Red
    fillColor: "#FFEBEE"
  },


  fromId(id) {
    return Object.values(academyGoldTnxTypeOptions).find(item => item.id === id) || academyGoldTnxTypeOptions.Buy;
  },

  toList() {
    return Object.values(academyGoldTnxTypeOptions).filter(item => typeof item !== 'function');
  }
});

export const academyGoldTnxStatusOptions = Object.freeze({
  Store: {
    id: 1,
    name: "Store",
    textColor: "#1565C0", // Blue
    fillColor: "#E3F2FD"
  },
  Take: {
    id: 2,
    name: "Take",
    textColor: "#6A1B9A", // Purple
    fillColor: "#F3E5F5"
  },
  Hold: {
    id: 3,
    name: "Hold",
    textColor: "#F57C00", // Orange
    fillColor: "#FFF3E0"
  },

  fromId(id) {
    return Object.values(academyGoldTnxStatusOptions).find(item => item.id === id) || academyGoldTnxStatusOptions.Store;
  },

  toList() {
    return Object.values(academyGoldTnxStatusOptions).filter(item => typeof item !== 'function');
  }
});


export const purchaseOrderStatus = Object.freeze({
  Pending: {
    id: 1,
    name: "Pending",
    textColor: "#F9A825", // Amber
    fillColor: "#FFF8E1"
  },
  Ordered: {
    id: 2,
    name: "Ordered",
    textColor: "#2E7D32", // Green
    fillColor: "#E8F5E9"
  },
  Rejected: {
    id: 3,
    name: "Rejected",
    textColor: "#C62828", // Red
    fillColor: "#FFEBEE"
  },
  Partial: {
    id: 4,
    name: "Partial",
    textColor: '#E35F00', fillColor: '#FFEBE6'
  },
   Received: {
    id: 5,
    name: "Received",
    textColor: '#1E3A8A', fillColor: '#E0F7FA'
  },

  fromId(id) {
    return Object.values(purchaseOrderStatus).find(item => item.id === id) || purchaseOrderStatus.Pending;
  },

  toList() {
    return Object.values(purchaseOrderStatus).filter(item => typeof item !== 'function');
  }
});

export const tovStatus = Object.freeze({
  Deleted:   { id: 0, name: 'Deleted',   textColor: '#9E9E9E', fillColor: '#F5F5F5' }, // Gray
  Pending:   { id: 1, name: 'Pending',   textColor: '#E68A00', fillColor: '#FFF4E5' }, // Amber/Orange
  Cancelled: { id: 2, name: 'Cancelled', textColor: '#D32F2F', fillColor: '#FFEBEE' }, // Red
  Complete: { id: 3, name: 'Complete', textColor: "#2E7D32", fillColor: "#E8F5E9" }, // Green

  fromId(id) {
    return Object.values(tovStatus).find(state => state.id === id) || tovStatus.Pending;
  },
  toList() {
    return Object.values(tovStatus).filter(state => typeof state !== 'function');
  }
});

export const gsTnxTypeOption = Object.freeze({
    NA:       { id: 0, name: "NA" },
    Gold:     { id: 1, name: "Gold" },
    Component:{ id: 2, name: "Component" },
    // Pandy:    { id: 3, name: "Pandy" },
    Stock:    { id: 3, name: "Stock" },

    fromId(id) {
        return Object.values(gsTnxTypeOption).find(item => item.id === id) || gsTnxTypeOption.NA;
    },

    toList() {
        return Object.values(gsTnxTypeOption).filter(item => typeof item !== "function");
    }
});

export const smithWorkOptions = Object.freeze({
    NA:        { id: 0, name: "N/A" },
    Handmade:  { id: 1, name: "Handmade" },
    Setting:   { id: 2, name: "Setting" },
    Bigstone:  { id: 3, name: "Bigstone" },
    ThreeD:    { id: 4, name: "3D" },
    Polish:    { id: 5, name: "Polish" },
    GoldCasting: { id: 8, name: "Gold Casting" },
    Dismantle: { id: 9, name: "Dismantle" },

    fromId(id) {
        return Object.values(smithWorkOptions).find(opt => opt.id === id) || smithWorkOptions.NA;
    },

    toList() {
        return Object.values(smithWorkOptions).filter(opt => typeof opt !== "function");
    }
});

export const smithWorkStatus = Object.freeze({
  NA:       { id: 0, name: "N/A",       textColor: "#9E9E9E", fillColor: "#F5F5F5" }, // Gray
  Working:  { id: 1, name: "Working",   textColor: "#1976D2", fillColor: "#E3F2FD" }, // Blue
  Review:   { id: 2, name: "Review",    textColor: "#E68A00", fillColor: "#FFF4E5" }, // Amber/Orange
  Complete: { id: 3, name: "Complete",  textColor: "#2E7D32", fillColor: "#E8F5E9" }, // Green

  fromId(id) {
    return Object.values(smithWorkStatus).find(state => state.id === id) || smithWorkStatus.NA;
  },
  toList() {
    return Object.values(smithWorkStatus).filter(state => typeof state !== "function");
  }
});


export const operationType = Object.freeze({
    CREATED : { id : 0, name : "CREATED"},
    SYSTEM_GENERATED : { id : 1, name : "SYSTEM_GENERATED"},
    EDITED : { id : 9, name: "EDITED"},
   
    fromId(id) {
      if(id == undefined) return
        return Object.values(operationType).find(state => state.id === id) || operationType.CREATED;
    },

    toList() {
        return Object.values(operationType).filter(state => typeof state !== 'function');
    }    
});
